<template>
  <div id="footer">
    <!-- <p>
      <span>{{configData.copyright}}</span>
      <span>|</span>
      <span>公司地址：{{configData.address}}</span>
      <span>|</span>
      <span>
        <a v-if="configData.logolink" :href="configData.logolink" target="_blank">联系我们</a>
      </span>
    </p>
    <p style="margin-top:5px">
      <span>
        <a href="http://www.beian.miit.gov.cn" target="_blank">{{configData.icp}}</a>
      </span>
      <img style="margin-bottom:-3px" alt src="../../assets/images/gaba.png">
      <span>
        <a :href="configData.opalink" target="_blank">{{configData.opa}}</a>
      </span>
    </p> -->
    <div class="footer-class" v-if="showCompanyName">
      <div>{{ name }}</div>
      <!-- 中南客户备案号不要 -5 -->
      <div><span @click="jumpto"
          style="cursor:pointer;">蜀ICP备17027707号-11&nbsp;</span>|&nbsp;版本号：V1.0&nbsp;|&nbsp;Artificial Intelligence
        Vision Engine Technology Corp.</div>
      <!-- <div ><span @click="jumpto" style="cursor:pointer;">蜀ICP备17027707号 </span>| 成都爱维译科技有限公司 提供技术支持</div> -->
    </div>
  </div>
</template>
<script>
import config from '@/utils/config'
export default {
  props: ['configData'],
  data() {
    return {
      showCompanyName: config.showCompanyName
    }
  },
  computed: {
    name() {
      return this.$store.state.enterpriseName
    }
  },
  methods: {
    jumpto() {
      window.open('http://www.beian.miit.gov.cn')
    }
  }
}
</script>
<style lang="scss" scoped>
#footer {
  width: 100%;
  height: 65px;
  background-color: #ffffff;
  color: #999999;
  text-align: center;
  font-size: 12px;
  border-top: 1px solid #dcdcdc;
  position: fixed;
  bottom: 0;
  line-height: 30px;
}

#footer a {
  color: #999999;
  text-decoration: none;
}

#footer p {
  width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/views/FooterVue/index.vue